import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class TableFetchService {

  constructor(private fireStore : AngularFirestore) { }

  fetchTowersSnapshot(tower){
    return this.fireStore.collection(tower).snapshotChanges();
  }
  fetchTowers(tower){
    return this.fireStore.collection(tower).get();
  }
  addTower(tower){
    return this.fireStore.collection(tower).doc(tower);
  }
  setData(year,towerID){
   return this.fireStore.collection('TOWERS').doc(year).collection(year).doc(towerID);
  }

  fetchData(towerName){
    return this.fireStore.collection(towerName).doc(towerName).get();
 }

}
